<template>
  <div id="game_list">
    <van-row>
      <van-col span="22" offset="1" v-for="item in list" :key="item.id" class="game_list_div">
        <van-col span="5">
          <van-image
            width="9vh"
            height="9vh"
            fit="cover"
            radius="10px"
            :src="item.img"
          />
        </van-col>
        <van-col span="13">
          <van-col span="24" class="game_list_name">{{ item.name }}</van-col>
<!--          <van-col span="24" class="game_list_sum">
            <span class="game_list_sum_color">5699</span>
            <span class="game_list_sum_size">{{ $t('column.players') }}</span>
          </van-col>-->
        </van-col>
        <van-col span="6" class="game_list_btn_div">
          <van-button color="#7232dd" round size="small" @click="play(item)">{{ $t('btn.play') }}</van-button>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
export default {
  data() {
    return {
      active: 0,
      list: [],
    }
  },
  created: function () {
    this.convert();
    document.title = this.$t('title.game_list')
  },
  methods: {
    convert: function () {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=room_game_list", {
        params: {
          uid: uid,
          token: token,
          type: 'h5'
        }
      }).then(res => {
        console.log(res.data)
        this.list = res.data.list
      })
    },
    play(item) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      let url = item.url
      url += (url.indexOf("?") == -1 ? "?" : "&"); //判断是否有问号
      url += 'uid='+ uid + '&token=' + token;
      window.location.href = url
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/game_list.vue